import { useCallback, FC } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { YouCanComeBackNote } from '../../../../general/components/footers/you-can-come-back-note';
import { WizardPage } from '../../../../general/components/wizard-page';
import { GET_STARTED } from '../../../../paths';
import { RootState } from '../../../../store';
import { BusinessInfoOneForm } from '../../components/business-info-1-form';

const selector = ({ nextStep: { error } }: RootState) => ({
  error,
});

const BusinessInfoOnePage: FC = () => {
  const navigate = useNavigate();
  const { error } = useSelector(selector);
  const handleBack = useCallback(() => {
    navigate(GET_STARTED);
  }, [navigate]);

  return (
    <WizardPage
      title="Tell us about your business"
      subtext="We’ll use this information to verify your company’s details."
      error={error}
      onBack={handleBack}
      footer={<YouCanComeBackNote />}
    >
      <BusinessInfoOneForm />
    </WizardPage>
  );
};

export { BusinessInfoOnePage };
